export function mobileFilterProperties() {
    let $filterFormProp = $('form#mob-filter-properties');
    if ($filterFormProp.length > 0) {
        $filterFormProp.on('change', 'select', function () {
            let _this = $(this);
            let $container = $('.map-mobile .locations');

            let data = {
                'action': 'filter_properties',
                'state': _this.val(),
            };

            $.ajax({
                url: ajaxvars.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                    _this.prop("disabled", true);
                },
                success: function (response) {
                    if (response) {
                        $container.html(response);
                    }
                },
                complete: function () {
                    _this.prop("disabled", false);
                }
            });

            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileFilterProperties.js